import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  verifyHeading: {
    "& p": {
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "23px",
      alignItems: "center",
      width: "100%",
      color: "#ffffff",
      margin: "0",
      paddingBottom: "15px",
      textAlign: "center",
      [theme.breakpoints.down("xl")]: {
        paddingTop: "10px",
        paddingBottom: "10px",
      },
    },
  },

  calIcon: {
    "& button": { padding: "0 15px !important", display: "none" },
  },

  active: {
    background: "#2B2B38",
    border: "1.4px solid rgba(255, 255, 255, 0.04)",
    boxShadow: "inset 0px 2px 12px rgba(255, 255, 255, 0.02)",
    borderRadius: "12px",
    "& a": {
      color: "#FFFFFF !important",
    },
  },

  signupFromWrap: {
    padding: "20px",
    backgroundColor: theme?.palette?.background?.providers,
    borderRadius: "0 0 12px 12px !important",
    [theme.breakpoints.down("md")]: {
      padding: "10px",
    },
    "& .MuiInputBase-fullWidth": {
      "&:before": {
        content: "''",
        display: "block",
        background: "url('/images/dropdown-icon.svg')",
        width: "10px",
        height: "6px",
        position: "absolute",
        top: "20px",
        right: "24px",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      },
      "& .MuiSelect-icon": {
        fill: "#1d1d23",
      },
    },
    "& .MuiInputBase-input:focus": {
      height: "44px",
      background: theme?.palette?.background?.default2,
      boxShadow: "inset 0px 2px 8px rgba(0, 0, 0, 0.12)",
      borderRadius: "12px",
      fontWeight: "500",
      fontSize: "14px",
      lineHeight: "23px",
      color: "#fff !important",
      padding: "0",
      paddingLeft: "20px",
      paddingRight: "50px",
    },
    "& .MuiInputBase-input": {
      height: "44px",
      background: theme?.palette?.background?.default2,
      boxShadow: "inset 0px 2px 8px rgba(0, 0, 0, 0.12)",
      borderRadius: "12px",
      fontWeight: "500",
      fontSize: "14px",
      lineHeight: "23px",
      color: "#fff !important",
      padding: "0",
      paddingLeft: "20px",
      paddingRight: "50px",
      "&::placeholder": {
        color: "#7d7d9f",
        fontWeight: "500",
        fontSize: "14px",
        [theme.breakpoints.down("md")]: {
          fontSize: "14px",
        },
      },
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#7458DC",
        },
      },
      [theme.breakpoints.down("md")]: {
        // height: "32px",
        lineHeight: "14px",
        fontSize: "14px",
        borderRadius: "8px",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "12px",
      borderColor: "transparent !important",
      backdropFilter: "inherit !important",
    },
    "& .MuiFormLabel-root": {
      // top: "-5px",
      fontSize: "14px",
      // color: "rgba(255, 255, 255, 0.3)",
    },
    "& fieldset": {
      borderColor: "transparent",
    },
  },

  formGroup: {
    position: "relative",
    marginBottom: "10px",
    "& .MuiSelect-select": {
      lineHeight: "44px",
    },

    "& .MuiInputLabel-formControl": {
      color: "#4D4D5B",
      padding: "0",
      fontSize: "18px",
      fontWeight: "500",
      lineHeight: "23px",
      [theme.breakpoints.down("md")]: {
        fontSize: "14px",
        lineHeight: "12px",
      },
    },
    "& .MuiFormControl-root": {
      width: "100%",
    },
    "& .MuiInputBase-adornedEnd": {
      paddingRight: "0",
      position: "relative",
    },
    "& .MuiInputAdornment-positionEnd": {
      position: "absolute",
      right: "0",
      "& button": {
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
    },
    "& span": {
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "20px",
      display: "flex",
      alignItems: "center",
      color: theme?.palette?.text?.color,
      marginBottom: "8px",
      [theme.breakpoints.down("md")]: {
        fontSize: "14px",
      },
    },
  },
  formInput: {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "20px",
    display: "flex",
    color: theme?.palette?.text?.textcolor,
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  wFull: {
    width: "100%",
  },
  signupCountryList: {
    maxHeight: "350px",
    zIndex: "9999 !important",
    "& .MuiMenu-paper": {
      background: theme?.palette?.background?.default,
    },
    "& .MuiMenu-list": {
      color: theme?.palette?.text?.textcolor,
      "& li": {
        fontFamily: "Jost!important",
      },
    },
  },

  btnPrimary: {
    background: theme?.palette?.background?.buttonbackground,
    border: theme?.palette?.background?.toggleBorder,
    boxShadow: theme?.palette?.background?.toggleShadow,
    borderRadius: "12px !important",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "26px",
    width: "100%",
    textTransform: "capitalize !important",
    color: "#FFFFFF !important",
    marginTop: "30px !important",
    marginBottom: "12px !important",
    "&:hover": {
      background: theme?.palette?.background?.buttonbackground,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
      lineHeight: "14px",
      marginBottom: "0px",
      borderRadius: "8px !important",
      marginTop: "20px",
    },
  },

  fileUploadBtn: {
    height: "200px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: `${theme?.palette?.background?.default2} !important`,
    borderRadius: "12px !important",
    padding: "20px !important",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      height: "140px",
    },
    "& input": {
      height: "100%",
      width: "100%",
      opacity: "0",
    },
    "& img": {
      position: "absolute",
      height: "100%",
      width: "100%",
      objectFit: "contain",
    },
    "&:hover": {
      backgroundColor: `${theme?.palette?.background?.default2} !important`,
    },
    "& button": {
      height: "200px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#1D1D23",
      borderRadius: "12px",
      "&:hover": {
        background: "#1D1D23",
      },
    },
  },

  userForm: {
    position: "relative",
    "& img": {
      width: "100%",
      display: "block",
    },
  },

  closeIconWrap: {
    top: "50px",
    color: "#858DA0",
    right: "20px",
    cursor: "pointer",
    display: "flex",
    opacity: 1,
    zIndex: 9,
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiSvgIcon-root": {
      fontSize: "20px",
    },
    "& svg": {
      fill: "#858DA0",
    },
    [theme.breakpoints.down("md")]: {
      top: "40px",
      right: "10px",
    },
    "&:hover": {
      // transform: "rotate(90deg)",
      transition: "transform 0.5s cubic-bezier(0.36, 0.66, 0.04, 1) 0s",
    },
  },

  "& .MuiDialogContent-root": {
    marginTop: "85px",
  },

  "& .MuiSelect-icon": {
    color: "#fff !important",
  },
  selectInput: {
    "& svg": {
      color: "#6D6F8A",
      fill: "#6D6F8A",
    },
  },
  kycContent: {
    height: "650px",
    overflowY: "scroll",
    paddingRight: "8px",
    [theme.breakpoints.down("xl")]: {
      height: "370px",
      "&::-webkit-scrollbar": {
        width: "2px",
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: "12px",
        backgroundColor: "#1D1D23",
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "8px",
        border: "1.4px solid rgba(255, 255, 255, 0.04)",
        backgroundColor: "#2B2B38",
        boxShadow: "0px 2px 12px 0px rgba(255, 255, 255, 0.02) inset",
      },
    },
  },
  errorMsgVal: {
    color: "red !important",
  },
}));
